import {ANNUAL, MONTHLY} from '@constants/period';
import type {Period} from '@interfaces/Period';

const MONTHS_IN_PERIOD = {
    [MONTHLY]: 1,
    [ANNUAL]: 12,
};

export function getPeriodMonthNum(period: Period): number {
    return MONTHS_IN_PERIOD[period];
}
